module.exports = __webpack_public_path__ + "media/promo/velle/images/products/prod_1-83ebf276ddbcc79e65859223825e68ec.png";